// import { createRoot } from "react-dom/client";
// import "./index.css";
// import App from "./App.tsx";
// import { ThemeProvider } from "./contexts/ThemeContext";
// import { FeedbackProvider } from "./shared/feedback/FeedbackProvider";
// import { TenantProvider } from "./shared/tenant/TenantProvider";

// createRoot(document.getElementById("root")!).render(
//   <ThemeProvider>
//     <FeedbackProvider>
//       <TenantProvider>
//         <App />
//       </TenantProvider>
//     </FeedbackProvider>
//   </ThemeProvider>
// );
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ConfigurationProvider } from './contexts/ContextoConfiguracion'
import { AuthProvider } from './contexts/ContextoAuth'
import { WorkspaceProvider } from './contexts/ContextoWorkspace'
import { ToastProvider } from './contexts/ContextoToast'
import { ProveedorContextoTema } from './contexts/ContextoTema'
import { SidebarProvider } from './contexts/ContextoSidebar'
import { ProveedorAyudaGuiada } from './shared/tour'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ProveedorContextoTema>
      <ToastProvider>
        <AuthProvider>
          <WorkspaceProvider>
            <SidebarProvider>
              <ConfigurationProvider>
                <ProveedorAyudaGuiada>
                  <App />
                </ProveedorAyudaGuiada>
              </ConfigurationProvider>
            </SidebarProvider>
          </WorkspaceProvider>
        </AuthProvider>
      </ToastProvider>
    </ProveedorContextoTema>
  </StrictMode>,
)
